function DigitalAawaz() {
    return (
        <div className="events-page-wrapper">
            <div className="container">
                <section className="events" style={{ paddingTop: '5rem' }}>
                    <h2>Digital आवाज</h2>
                    <p style={{ textAlign: 'center', color: 'var(--mid-text)', marginTop: '1rem' }}>
                        Full event details coming soon.
                    </p>
                </section>
            </div>
        </div>
    );
}
export default DigitalAawaz;